var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBsc = function SvgBsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BSC_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BSC_svg__b)",
    fill: "#F3BA2F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.116 8.404 3.885-3.884 3.885 3.886 2.26-2.26L10.002 0 3.856 6.144l2.26 2.26M0 10.001 2.26 7.74 4.52 10l-2.26 2.26L0 10Zm6.116 1.595 3.885 3.884 3.885-3.886 2.262 2.26L10 20l-6.145-6.145-.003-.003 2.263-2.257m9.364-1.595 2.26-2.26L20.001 10l-2.26 2.26-2.26-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.292 10-2.291-2.294L8.305 9.4l-.195.195-.401.402-.003.003.003.003L10 12.294l2.293-2.293h-.002"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "BSC_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "BSC_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgBsc;